import { render, staticRenderFns } from "./product_service_tag.vue?vue&type=template&id=69d3d70b"
import script from "./product_service_tag.vue?vue&type=script&lang=js"
export * from "./product_service_tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports